import { Fragment, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import  _ from 'lodash';

import AddPayOutAddress from "../AddPayOutAddress/AddPayOutAddress";
import Backdrop from "../../Backdrop/Backdrop";
import Loader from "../../Loader/Loader";
import Modal from "../../Modal/Modal";
import PayOutAddressListItem from "./PayOutAddressListItem";

import { useStore } from "../../../hook-store/store";

import { 
  getUserAdHostPayOutAddress,
} from "../../../utils/pay-out-address/pay-out-address-util";

import { NODEURL } from "../../../App";

import classes from './PayOutAddressList.module.css';

function PayOutAddressList(props) {

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { userPayOutAddress } = store.payOutStore;

  const [showAddAddress, setShowAddAddress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    getUserPayOutAddressHandler();
  },[]);

  const getUserPayOutAddressHandler = async () => {
    try {
      setIsLoading(true);

      const resData = await getUserAdHostPayOutAddress(
        NODEURL,
        localStorage.getItem('token'),
      );
  
      console.log(resData);
      
      if (resData.data) {
        // setUserPayoutAddress(resData.data);
        dispatch('SET_USERPAYOUTADDRESS', resData.data);
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };


  let payOutAddressListBody;

  if (userPayOutAddress && userPayOutAddress.addressList.length > 0) {
    
    const displayList = _.sortBy(userPayOutAddress.addressList.reverse(), 
      [function(o) { return o.coin; }]);

    payOutAddressListBody = (
      <ul>
        {displayList.map(address => {

          const isUseAddress = address.id === userPayOutAddress.useAddressId;

          return (
            <li key={address.id}
              // style={{border:"1px solid red"}}
            >
              <PayOutAddressListItem 
                address={address}
                isUseAddress={isUseAddress}
              />
            </li>
          );
        })}
      </ul>
    );
  }
  return (
    <Fragment>
      <div className={classes.payOutAddressList}>
        
        {/* <div>payout-address-component</div> */}

        <section className={classes.payOutAddressListAdd}>
          <div>
            <button className="btnBase"
              disabled={isLoading}
              onClick={() => { setShowAddAddress(true); }}
            >
              {t('payOutAddress01', 'Add new payout address')}
            </button>
          </div>

          {showAddAddress && (
            <div>
              <Backdrop 
                onCancel={() => { setShowAddAddress(false); }}
              />
              <Modal
                onCancel={() => { setShowAddAddress(false); }}
                isLoading={isLoading}
              >
                <AddPayOutAddress 
                  setShowAddAddress={setShowAddAddress}
                />
              </Modal>
            </div>
          )}
        </section>

        <section>
          {isLoading && (<Loader />)}
          <div className={classes.payOutAddressListList}>
            {payOutAddressListBody}
          </div>
        </section>

      </div>
    </Fragment>
  );
}

export default PayOutAddressList;
